import { css } from 'styled-components'
import { theme } from '../theme'

export const ScrollbarStyle = css`
  scrollbar-width: thin;
  scrollbar-color: ${theme.colors.lightGray} ${theme.colors.gray};

  &::-webkit-scrollbar {
    border-radius: 20px;
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background-color:  ${theme.colors.mainBg};
  }

  &::-webkit-scrollbar-thumb {
    background-color:  ${theme.colors.gray};
    border-radius: 20px;
  }
`
